import { AvcorePublishStreamApiCredentials } from "@common/domain";
import { StreamData } from "../../actions";
import { ExtendedMediaStream } from "../../extended-media-stream";
import { assert } from "../../utils";
import { ConferenceApi } from "./ConferenceApi";

export class PublishConferenceApi extends ConferenceApi {
  private _published = false;

  constructor(
    readonly streamData: StreamData,
    readonly streamApiCredentials: AvcorePublishStreamApiCredentials,
    logger: (...args: unknown[]) => void
  ) {
    super(streamData, streamApiCredentials, logger);
  }

  override async destroy() {
    await super.destroy();
  }

  async publish(origin: ExtendedMediaStream) {
    assert(!this._published, "Stream single publish invariant is broken-down");

    this._published = true;

    return super.publish1(origin.stream);
  }

  override async addTrack(track: MediaStreamTrack) {
    return super.addTrack(track);
  }

  override async removeTrack(track: MediaStreamTrack) {
    return super.removeTrack(track);
  }
}
